var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-container"},[_c('VuePdfApp',{attrs:{"pdf":_vm.pdf}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }